import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { handleGetPopularGames } from "../../api-clients/gamesClient";

interface UsePopularGamesQueryParams {
  limit?: number;
}

function usePopularGamesQuery(params?: UsePopularGamesQueryParams) {
  const { limit } = params || {};

  const query = useQuery({
    queryKey: [QUERY_KEYS.GAME.POPULAR_GAMES, limit],
    queryFn: () => handleGetPopularGames({ limit }),
  });

  return query;
}

export default usePopularGamesQuery;
